module.exports = __webpack_public_path__ + "img/imagen_10anios.944821d5.jpg";